export const roundToDecimal = (val: number, decimalPoints = 0): number => {
  if (Number.isInteger(val)) {
    return val;
  }

  const multiplier = 10 ** decimalPoints;
  const roundedAbs = Math.round(Math.abs(val) * multiplier) / multiplier;

  return val < 0 ? -roundedAbs : roundedAbs;
};

export const roundToDecimalFixedString = (
  val: number,
  decimalPoints: number,
): string => {
  return roundToDecimal(val, decimalPoints).toFixed(decimalPoints);
};
